<template>
	<div class="height-100dvh">
		<div
			style="
				position: fixed;
				top: 60px;
				z-index: 10000;
				left: 0px;
				backdrop-filter: blur(2px);
				width: 100%;
			"
			v-if="roadMapLoader || LoaderStatus"
		>
			<Spinner id="nomargin" />
		</div>
		<header class="mob-back-header" v-if="hasAccess">
			<img
				class="mr-3"
				@click="handleBack()"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			{{ headerText }}
		</header>
		<main
			class="interview-skill-container"
			:class="!hasAccess ? 'guest-padding' : ''"
		>
			<div id="hideinmobile" class="cand-header d-flex mb-2" v-if="hasAccess">
				<img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="handleBackLaptop()"
				/>
				{{ headerText }}
			</div>
			<div class="inski-container">
				<div
					v-if="hasAccess"
					v-show="isMobile ? showLeftSection : true"
					class="inki-left"
					:class="byCompany ? 'mob-inki-height' : ''"
				>
					<template v-if="!byCompany">
						<div class="fam-lato fw-LM fs-13 text-3A3C40 px-3">
							Search for additional skills to expand your options
						</div>
						<div
							class="position-relative px-3 mt-2"
							v-closable="{
								exclude: ['searchoption'],
								handler: 'closeSuggestions',
							}"
						>
							<img
								class="resumes-search-image-position"
								src="../../assets/headerSearch.svg"
								alt=""
							/>
							<b-form-input
								class="resumes-search-input"
								placeholder="Search"
								debounce="500"
								v-model="tempSearchQuery"
								@update="searchSkills"
								@focus="searchSkills"
								type="search"
								clearable
							>
							</b-form-input>
							<ul
								ref="searchoption"
								class="sws-select-options"
								v-if="searchOptions.length && tempSearchQuery"
							>
								<li
									v-for="(option, i) in searchOptions"
									:key="i"
									class="search-select-option px-3 py-2"
									@click="selectOption(option, i)"
								>
									{{ option.text }}
								</li>
							</ul>
						</div>
						<hr class="mx-3 mt-12" />
						<div class="fam-mont fw-M fs-14 text-darkgrey px-3 my-3">
							Skills from your primary profile
						</div>
						<div class="inki-left-overflow" v-if="loadingSkills">
							<div v-for="i in 7" :key="i" class="skill">
								<span class="fam-mont fw-M fs-14 text-blue w-100">
									<b-skeleton class="w-100"></b-skeleton>
								</span>
								<article class="tag w-100 d-flex justify-content-end">
									<b-skeleton class="w-50"></b-skeleton>
								</article>
							</div>
						</div>
						<div class="inki-left-overflow" v-else>
							<div
								v-for="(skill, index) in profileSkills"
								:key="index"
								:class="
									index == selectedProfileInd && !recommended
										? 'skill selected pointer'
										: 'skill pointer'
								"
								@click="handleSkillClick(skill, index), (firstTime = true)"
							>
								<span class="fam-mont fw-M fs-14 text-blue">{{
									normalizeSkillName(skill.name)
								}}</span>
								<article class="tag" v-if="skill.fromProfile">
									<img
										class="mr-2"
										src="../../assets/img/aiInterview/from-profile.svg"
										alt=""
									/>
									From Profile
								</article>
							</div>
						</div>
						<hr class="mx-3 mt-12" />
						<div class="fam-mont fw-M fs-14 text-darkgrey px-3 my-3">
							Recommended Skills for you:
						</div>
						<div
							class="d-flex flex-wrap gap-3 recomended px-3"
							v-if="loadingSkills"
						>
							<div v-for="i in 4" :key="i" class="blue-recom">
								<b-skeleton class="w-100"></b-skeleton>
							</div>
						</div>
						<div class="d-flex flex-wrap gap-3 recomended px-3" v-else>
							<div
								v-for="(skill, index) in recommendedSkills"
								:key="index"
								:class="
									index == selectedProfileInd && recommended ? 'recom-sel' : ''
								"
								class="text-capitalize pointer text-truncate"
								@click="
									handleSkillClick(skill, index, true), (firstTime = true)
								"
							>
								{{ normalizeSkillName(skill.name) }}
							</div>
						</div>
					</template>
					<template v-else>
						<div class="iski-topDiv px-3">
							<InputField
								:vmodel="formData.companyName"
								:label="'Company Name'"
								:type="'text'"
								:mandatory="true"
								:placeholder="'Enter'"
								:showError="formErrors.companyName"
								@select-value="updateFormData('companyName', $event)"
							/>
							<InputField
								:vmodel="formData.companyRoleName"
								class="mt-3"
								:label="'Role'"
								:type="'text'"
								:mandatory="true"
								:placeholder="'Enter'"
								:showError="formErrors.companyRoleName"
								@select-value="updateFormData('companyRoleName', $event)"
							/>
							<InputField
								:vmodel="formData.companyBio"
								class="has-optional mt-3"
								:label="'Company Bio'"
								:type="'text'"
								:mandatory="false"
								:placeholder="'Enter'"
								@select-value="updateFormData('companyBio', $event)"
							/>
							<Textarea
								:vmodel="formData.jobDescription"
								class="has-optional mt-3"
								placeholder="Enter"
								:label="'Job Description'"
								:limit="256"
								:mandatory="false"
								type="text"
								@select-value="updateFormData('jobDescription', $event)"
							/>
						</div>

						<div
							class="position-relative d-flex justify-content-center w-100 mt-3"
						>
							<b-button
								class="candash-addBtn"
								:class="
									loadPrepare ? 'loader-class-prep defaultCursor ' : ' pointer'
								"
								@click="prepareNow()"
								:disabled="
									loadPrepare ||
									(!isSkillExtracting &&
										!isFormValid &&
										!formData.companyName &&
										!formData.companyRoleName)
								"
								>Prepare Now</b-button
							>
							<div v-if="loadPrepare" class="loader-pos-new">
								<Loader />
							</div>
						</div>
						<div v-if="recentSearch.length">
							<hr class="hr-back mx-3" />
							<div class="fam-mont fs-14 fw-M text-darkgrey ml-3 iski-mob-ml">
								My Roadmap & Recent Searches:
							</div>
							<article
								v-for="(role, index) in recentSearch"
								:key="index"
								class="fam-mont fs-14 mt-3 mx-3"
								:class="[
									index == selectedProfileInd && !recommended
										? 'white-recom pointer'
										: 'blue-recom pointer',
									index == 0 &&
									$route.query.from == 'jobsearch' &&
									selectedProfileInd === 0 &&
									!recommended
										? 'jobsearch-highlight'
										: '',
								]"
								@click="handleJobRoleClick(role, index)"
							>
								<div>
									<span class="text-3a3c40 fw-LM">{{
										role.companyRoleName || role.title
									}}</span
									><span class="text-blue fw-M">
										|
										{{ getDisplayName(role) }}
									</span>
								</div>
							</article>
						</div>
						<div>
							<hr class="hr-back mx-3" />
							<div class="fam-mont fs-14 fw-M text-darkgrey ml-3 iski-mob-ml">
								Recommended for you:
							</div>
							<div v-if="loadingRecommendedrole">
								<article
									v-for="i in 5"
									:key="i"
									class="blue-recom-role fam-mont fs-14 mt-3 mx-3"
								>
									<div class="text-blue fw-M">
										<b-skeleton class="w-100 h-100"></b-skeleton>
									</div>
									<div class="text-3a3c40 fw-LM">
										<b-skeleton class="w-80 h-100"></b-skeleton>
									</div>
								</article>
							</div>
							<div v-else>
								<article
									v-for="(jobRole, index) in recommendedJobRole"
									:key="index"
									class="fam-mont fs-14 mt-3 mx-3"
									:class="
										index == selectedProfileInd && recommended
											? 'white-recom pointer'
											: 'blue-recom-role pointer'
									"
									@click="handleJobRoleClick(jobRole, index, true)"
								>
									<div class="text-blue fw-M">{{ jobRole.company_name }}</div>
									<div class="text-3a3c40 fw-LM">{{ jobRole.role }}</div>
								</article>
							</div>
						</div>
					</template>
				</div>
				<div
					v-show="isMobile ? !showLeftSection : true"
					class="inki-right"
					:style="!hasAccess ? 'width: 100%' : ''"
				>
					<div id="hideinlaptop" class="iski-mob-collapse">
						<div
							class="fam-mont fw-B fs-18 text-white mb-3 d-flex align-items-center"
							v-if="loadingData"
						>
							<b-skeleton class="w-50 mb-0" height="27px"></b-skeleton>
							<span style="opacity: 0.5; font-weight: 300; margin: 0 8px"
								>|</span
							>
							<b-skeleton class="w-25 mb-0" height="27px"></b-skeleton>
						</div>
						<article
							class="fam-mont fw-B fs-18 text-white mb-3"
							v-else-if="selectedSkill"
							v-html="
								byCompany
									? displayCompanyName
									: (selectedSkill &&
											selectedSkill.skill &&
											normalizeSkillName(selectedSkill.skill.name)) ||
									  ''
							"
						></article>
						<b-collapse v-model="mobCollapse">
							<div class="py-3 d-flex gap-3 dashed-div" v-if="loadingSkills && hasAccess">
								<div
									class="card d-flex align-items-center justify-content-center p-3"
								>
									<b-skeleton
										width="100px"
										height="15px"
										class="mb-2"
									></b-skeleton>
									<b-skeleton
										type="avatar"
										width="24px"
										height="24px"
									></b-skeleton>
								</div>
								<div
									class="card d-flex align-items-center justify-content-center p-3"
								>
									<b-skeleton
										width="100px"
										height="15px"
										class="mb-2"
									></b-skeleton>
									<b-skeleton
										type="avatar"
										width="24px"
										height="24px"
									></b-skeleton>
								</div>
							</div>
							<div class="py-3 d-flex gap-3 dashed-div" v-else>
								<div class="card pointer" @click="getSkillRoadmapSuggestions()">
									<span class="fam-mont fw-B fs-13 text-blue">{{
										selectedSkill && selectedSkill.skill.roadMapCreated
											? "View My Roadmap"
											: "Create  My Roadmap"
									}}</span>
									<img
										src="../../assets/img/aiInterview/mob-roadMap.svg"
										alt=""
									/>
								</div>
								<div class="card pointer" @click="handleMockInterviewClick()">
									<span class="fam-mont fw-B fs-13 text-blue"
										>Mock AI Interview</span
									>
									<img
										src="../../assets/img/aiInterview/mob-ai-inter.svg"
										alt=""
									/>
								</div>
							</div>
						</b-collapse>
					</div>
					<div id="hideinmobile" class="dflex-1">
						<template v-if="loadingSkills  && hasAccess">
							<div
								class="roadmap align-items-center justify-content-between p-3 border rounded mb-3"
							>
								<div class="d-flex align-items-center">
									<b-skeleton
										type="avatar"
										width="40px"
										height="40px"
									></b-skeleton>
									<div class="ml-3">
										<div
											class="fam-mont fw-B fs-16 text-blue d-flex align-items-center mb-1"
										>
											<b-skeleton width="150px" class="mb-0"></b-skeleton>
										</div>
										<div class="fam-lato fw-LM fs-13 text-3A3C40 mt-1 mb-2">
											<b-skeleton width="250px" class="mb-0"></b-skeleton>
										</div>
										<div class="mt-12">
											<b-skeleton
												type="button"
												width="130px"
												height="35px"
											></b-skeleton>
										</div>
									</div>
								</div>
							</div>
							<div
								class="mockInter align-items-center justify-content-between p-3 border rounded mb-3"
							>
								<div class="d-flex align-items-center">
									<b-skeleton
										type="avatar"
										width="40px"
										height="40px"
									></b-skeleton>
									<div class="ml-3">
										<div
											class="fam-mont fw-B fs-16 text-blue d-flex align-items-center mb-1"
										>
											<b-skeleton width="150px" class="mb-0"></b-skeleton>
										</div>
										<div class="fam-lato fw-LM fs-13 text-3A3C40 mt-1 mb-2">
											<b-skeleton width="250px" class="mb-0"></b-skeleton>
										</div>
										<div class="mt-12">
											<b-skeleton
												type="button"
												width="130px"
												height="35px"
											></b-skeleton>
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div
								class="roadmap align-items-center justify-content-between p-3 border rounded mb-3"
							>
								<div class="d-flex align-items-center">
									<img
										src="../../assets/img/prepInterview/createRoad.svg"
										alt=""
									/>
									<div class="ml-3">
										<div
											class="fam-mont fw-B fs-16 text-blue d-flex align-items-center"
										>
											{{
												selectedSkill && selectedSkill.skill.roadMapCreated
													? "View My Roadmap"
													: "Create My Roadmap"
											}}
											<img
												class="ml-2"
												src="../../assets/img/prepInterview/hireai.svg"
												alt=""
											/>
										</div>
										<div class="fam-lato fw-LM fs-13 text-3A3C40 mt-1">
											Search for additional skills to expand your options
										</div>
										<div class="mt-12">
											<b-button
												@click="getSkillRoadmapSuggestions()"
												class="candash-addBtn"
												:disabled="hasAccess ? selectedSkill == null : false"
											>
												<span>
													{{
														selectedSkill &&
														(selectedSkill.skill.roadMapCreated ||
															(this.selectedCompany &&
																this.selectedCompany.roadMap))
															? "View Roadmap"
															: "Create Roadmap"
													}}</span
												>
											</b-button>
										</div>
									</div>
								</div>
							</div>
							<div
								class="mockInter align-items-center justify-content-between p-3 border rounded mb-3"
							>
								<div class="d-flex align-items-center">
									<img src="../../assets/img/prepInterview/mockAi.svg" alt="" />
									<div class="ml-3">
										<div
											class="fam-mont fw-B fs-16 text-blue d-flex align-items-center"
										>
											Mock AI Interview
											<img
												class="ml-2"
												src="../../assets/img/prepInterview/hireai.svg"
												alt=""
											/>
										</div>
										<div class="fam-lato fw-LM fs-13 text-3A3C40 mt-1">
											Search for additional skills to expand your options
										</div>
										<div class="mt-12 d-flex align-items-center">
											<b-button
												class="candash-addBtn"
												@click="startInterview()"
												:disabled="hasAccess ? selectedSkill == null : false"
											>
												Start Interview
											</b-button>
											<b-button
												class="candash-cancelBtn ml-3"
												:disabled="selectedSkill == null || !mockInterviewTaken"
												@click="goToReports()"
											>
												View Reports
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
					<b-tabs
						id="hideinlaptop"
						class="w-100"
						v-model="activeTab"
						@input="checkActiveTab"
					>
						<b-tab active>
							<template #title>
								Your assessments<span
									class="fam-lato fw-LM fs-10 text-blue d-flex align-item s-center justify-content-center ml-2"
									>{{ assessmentTotal }}</span
								>
							</template>
						</b-tab>
						<b-tab>
							<template #title>
								Your courses<span
									class="fam-lato fw-LM fs-10 text-blue d-flex align-items-center justify-content-center ml-2"
									>{{ courseTotal }}</span
								>
							</template>
						</b-tab>
					</b-tabs>
					<div
						id="hideinlaptop"
						class="d-flex justify-content-end align-content-center fam-lato fw-LM fs-12 text-tertiary pr-3"
					>
						<span
							>Completed {{ activeTab == 0 ? "Assessments" : "Courses" }}:</span
						><span
							>&nbsp;{{
								activeTab == 0 ? completedTestCount : completedCourseCount
							}}</span
						>
					</div>
					<div
						class="mob-mt-4 inki-right-overflow"
						:class="!hasAccess && 'inki-right-overflow-loggedout'"
					>
						<div id="hideinmobile" class="inki-skill-heading">
							<div class="d-flex align-items-center w-50" v-if="loadingData">
								<b-skeleton class="w-50 mb-0" height="27px"></b-skeleton>
								<span style="opacity: 0.5; font-weight: 300; margin: 0 8px"
									>|</span
								>
								<b-skeleton class="w-25 mb-0" height="27px"></b-skeleton>
							</div>
							<span
								class="fam-mont fw-B fs-18 text-white"
								v-else
								v-html="
									byCompany
										? displayCompanyName
										: (selectedSkill &&
												selectedSkill.skill &&
												normalizeSkillName(selectedSkill.skill.name)) ||
										  ''
								"
							></span>
							<div class="d-flex align-items-center fs-14">
								<span class="mr-2">Courses :</span
								><span>{{ courseTotal }}</span>
								<div class="vert-line mx-3"></div>
								<span class="mr-2">Assessments :</span
								><span>{{ assessmentTotal }}</span>
							</div>
						</div>
						<div class="inki-collapse">
							<article
								id="hideinmobile"
								@click="
									(showAssessments = !showAssessments),
										(showCourses = !showCourses)
								"
								class="d-flex align-items-center justify-content-between header sticky-header"
							>
								<div class="fam-mont fw-M fs-16" v-if="!loadingData">
									Assessments
								</div>
								<div class="d-flex align-items-center gap-4 ml-auto">
									<article
										class="completed-tag d-flex align-items-center gap-2"
									>
										<span class="fw-R fs-12 text-666666">Completed:</span
										><span class="fam-mont fw-B fs-14 text-blue">{{
											completedTestCount
										}}</span>
									</article>
									<img
										src="../../assets/img/prepInterview/dropdown.svg"
										alt=""
									/>
								</div>
							</article>
							<div class="assessment-list-wrapper">
								<AssessmentList
									:showAssessments="showAssessments"
									:assessmentSuggestions="assessmentSuggestions"
									:loadingData="loadingData"
									:loadingMore="loadingMore"
									:email="candidateData.email"
									:pageStart="assessmentPageStart"
									:pageEnd="assessmentPageEnd"
									:pageTotal="assessmentTotal"
									@load-assessment="handleAssessmentScroll"
								/>
							</div>
						</div>
						<div class="inki-collapse">
							<article
								id="hideinmobile"
								@click="
									(showAssessments = !showAssessments),
										(showCourses = !showCourses)
								"
								class="d-flex align-items-center justify-content-between header"
							>
								<div class="fam-mont fw-M fs-16" v-if="!loadingData">
									Courses
								</div>
								<div class="d-flex align-items-center gap-4 ml-auto">
									<article
										class="completed-tag d-flex align-items-center gap-2"
									>
										<span class="fw-R fs-12 text-666666">Completed:</span
										><span class="fam-mont fw-B fs-14 text-blue">{{
											completedCourseCount
										}}</span>
									</article>
									<img
										src="../../assets/img/prepInterview/dropdown.svg"
										alt=""
									/>
								</div>
							</article>
							<b-collapse v-model="showCourses">
								<div class="body courses-wrapper">
									<div id="hideinmobile" class="dashed-div"></div>
									<div
										v-if="!loadingData && !coursesList.length"
										class="d-flex flex-column align-items-center justify-content-center no-assessment"
									>
										<img
											src="../../assets/img/prepInterview/no-courses.svg"
											alt=""
										/>
										<p class="fs-18 fam-lato fw-R text-666666 mt-2 text-center">
											No Courses Found
										</p>
									</div>

									<div
										v-else
										class="scrollable-list"
										ref="scrollCourseContainer"
										@scroll="onCourseScroll"
									>
										<template v-if="loadingCourse">
											<div
												v-for="i in 5"
												:key="i"
												class="d-flex course-card mb-2"
											>
												<div class="main-dp">
													<b-skeleton
														height="100%"
														style="width: 100%"
													></b-skeleton>
												</div>

												<div
													class="d-flex flex-column align-items-start justify-content-between justify-content-between w-75 ml-3"
												>
													<b-skeleton
														width="25%"
														style="height: 21px"
														class="mb-2"
													></b-skeleton>
													<b-skeleton
														width="50%"
														style="height: 21px"
														class="mb-2"
													></b-skeleton>

													<b-skeleton
														width="75%"
														style="height: 21px"
														class="mb-2"
													></b-skeleton>
													<b-skeleton
														width="100%"
														style="height: 21px"
														class="mb-2"
													></b-skeleton>
												</div>
											</div>
										</template>
										<template v-else>
											<div
												v-for="(course, index) in coursesList"
												:key="index"
												class="d-flex course-card mb-2"
											>
												<div class="main-dp">
													<img
														class="w-100 h-100"
														:src="
															course.thumbnail ||
															require('@/assets/newdesign/home/default_courseimg.svg')
														"
														alt=""
													/>
												</div>
												<div class="d-flex flex-1 pl-3 mob-flex-column">
													<div
														class="d-flex flex-column align-items-start justify-content-between justify-content-between"
													>
														<div>
															<h5
																class="fam-lato fw-LM mob-fw-600 fs-18 mob-fs-12 text-name"
															>
																{{ course.title }}
															</h5>
															<div
																class="d-flex align-items-center gap-3 mob-gap-3 fam-mont fs-11 mob-fs-10 fw-R text-3A3C40op word-break"
															>
																<img
																	src="../../assets/img/aiInterview/single-user-updated.svg"
																	alt=""
																/><span
																	>{{ course.instructorInfo?.firstName
																	}}{{ course.instructorInfo?.lastName }}</span
																><img
																	src="../../assets/img/aiInterview/group-updated.svg"
																	alt=""
																/><span
																	>{{
																		course.enrollmentsCount
																	}}
																	Candidates</span
																>
															</div>
														</div>
														<div
															id="hideinmobile"
															class="align-items-center gap-3 fam-mont fs-13 fw-R text-3A3C40op double-line-truncate"
															v-html="course.description"
														></div>
														<div
															class="d-flex align-items-center"
															v-if="course.ratingSummaryInfo"
														>
															<span
																v-if="
																	course.ratingSummaryInfo.overallRating > 0
																"
																class="fam-mont fw-M fs-18 mob-fs-12 text-blue"
																>{{
																	course.ratingSummaryInfo.overallRating
																}}</span
															>
															<div class="course-rating">
																<b-form-rating
																	:value="
																		course.ratingSummaryInfo.overallRating
																	"
																	variant="warning"
																	readonly
																></b-form-rating>
															</div>
															<span
																id="hideinmobile"
																class="fam-mont fw-R fs-12"
															>
																({{ course.ratingSummaryInfo.noOfRatings }})
															</span>
														</div>
													</div>
													<hr class="hr-back" />
													<div
														class="d-flex flex-column inki-dflex align-items-end justify-content-between justify-content-around"
													>
														<div id="hideinmobile">
															<img
																class="pointer"
																v-if="!course.wishlistInfo"
																@click="addToWishlist(course)"
																src="../../assets/img/aiInterview/blue-shaded-like.svg"
																alt=""
															/>
															<img
																v-else
																class="pointer"
																@click="addToWishlist(course)"
																src="../../assets/img/aiInterview/liked-shaded-blue.svg"
																alt=""
															/>
														</div>
														<div class="inki-dflex gap-2">
															<div
																class="fam-mont fw-M fs-16 mob-fs-13 text-blue"
															>
																{{
																	course.pricing.finalPrice > 0
																		? `₹${course.pricing.finalPrice}`
																		: "Free"
																}}
															</div>
															<div
																class="fam-mont fw-R fs-12 mob-fs-10 text-muted text-decoration-line-through"
																v-if="course.pricing.finalPrice > 0"
															>
																₹{{ course.pricing.listPrice }}
															</div>
														</div>
														<div>
															<b-button
																id="hideinmobile"
																class="candash-addBtn"
																@click="goToCourse(course)"
																>{{ getButtonText(course) }}</b-button
															>
															<div
																id="hideinlaptop"
																@click="goToCourse(course)"
																class="fam-mont fw-M fs-12 text-blue"
															>
																{{ getButtonText(course) }}
															</div>
														</div>
													</div>
												</div>
											</div>
										</template>
									</div>
									<div
										v-if="loadmoreCourse"
										class="d-flex justify-content-center py-2"
									>
										<b-spinner label="Loading..."></b-spinner>
									</div>
								</div>
							</b-collapse>
						</div>
					</div>
				</div>
			</div>
			<Transition name="slide">
				<div v-if="showTrans" class="jdprog-trans-main-cont">
					<div
						id="hideinmobile"
						class="d-flex align-items-center justify-content-between position-relative"
					>
						<img
							@click="showTrans = false"
							class="transArrow-pos"
							src="../../assets/newdesign/jdprogress/transBackArrow.svg"
							alt=""
						/>
						<div class="candash-modal-label-3 pl-4">
							{{ normalizeSkillName(selectedSkill.skill.name) }}
						</div>

						<div>
							<img
								class="pointer"
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
								@click="showTrans = false"
							/>
						</div>
					</div>
					<hr id="hideinmobile" class="hr-back mb-0" />
					<div class="jdp-trans-overflow-2 roadmap-overparent">
						<div v-html="roadMapHtml"></div>
					</div>
				</div>
			</Transition>
		</main>

		<!-- Mobile Bottom Collapse Options -->
		<div
			v-if="showMobileOptions"
			class="mobile-options-overlay"
			@click.self="showMobileOptions = false"
		>
			<div class="mobile-options-sheet">
				<div class="d-flex justify-content-center pt-2 pb-3">
					<div class="sheet-handle"></div>
				</div>
				<h3 class="fam-mont fw-B fs-18 text-3A3C40 mb-4 px-3">Select Option</h3>

				<div
					class="option-card mb-3 mx-3 p-3 d-flex align-items-center gap-3 pointer"
					@click="startInterview()"
				>
					<div class="icon-box">
						<img
							src="../../assets/img/aiInterview/mob-ai-inter.svg"
							alt="Mock Interview"
							width="40"
						/>
					</div>
					<div>
						<div class="fam-mont fw-B fs-14 text-blue mb-1">
							Take Mock Interview
						</div>
						<div class="fam-lato fw-R fs-12 text-666666">
							Learn practical, in-demand skills to stay ahead in your career
							journey.
						</div>
					</div>
				</div>

				<div
					class="option-card mb-4 mx-3 p-3 d-flex align-items-center gap-3 pointer"
					@click="goToReports()"
				>
					<div class="icon-box">
						<img
							src="../../assets/img/aiInterview/view-report.svg"
							alt="View Reports"
							width="30"
						/>
					</div>
					<div>
						<div class="fam-mont fw-B fs-14 text-blue mb-1">View Reports</div>
						<div class="fam-lato fw-R fs-12 text-666666">
							Take role-based assessments to showcase your capabilities with
							confidence.
						</div>
					</div>
				</div>
			</div>
		</div>
		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
	</div>
</template>
<script>
import InputField from "@/components/InputComponents/Input.vue";
import Textarea from "@/components/InputComponents/Textarea.vue";
import commonFunction from "@/components/mixin/commonFunction";
import AssessmentList from "@/components/PrepareforInterview/AssessmentList.vue";
import { hasAccess as checkHasAccess } from "@/utils/tokenCheck";
import {
	getProfileSkills,
	getAssessmentSuggestions,
	getSkillSuggestions,
	getSkillRoadmapSuggestions,
	getRoadmapRecommendedJobs,
	extractSkills,
	getcoursesList,
	toggleWishlist,
} from "@/utils/apiFunctions";
import Loader from "@/components/fixedcomponents/Loader.vue";
import toast from "@/components/mixin/toast";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";
import { mapGetters } from "vuex";
import EventBus from "../../utils/EventBus";
import { config } from "@/config";

export default {
	data() {
		// Check if coming back from reports with a selected company
		const isMobile =
			typeof window !== "undefined" ? window.innerWidth <= 1028 : false;
		const query = this.$route?.query || {};
		const shouldShowRightPanel =
			isMobile &&
			// Returning from reports with a selected company
			((query.byCompany === "1" && query.index !== undefined) ||
				// Coming from job search — skip directly to right panel
				(query.from === "jobsearch" && !!query.bycompany));

		return {
			loadPrepare: false,
			mobCollapse: true,
			LoaderStatus: false,
			showMobileOptions: false,
			mockInterviewTaken: 0,
			assessmentPage: 0,
			byCompany: false,
			showAssessments: true,
			showCourses: false,
			showTrans: false,
			showLeftSection: !shouldShowRightPanel, // Set based on query params
			isMobile: isMobile,
			profileSkills: [],
			recommendedSkills: [],
			selectedProfileInd: null,
			activeTab: 0,
			loadingSkills: true,
			tempSearchQuery: "",
			assessmentSuggestions: [],
			assessmentPageEnd: 0,
			assessmentPageStart: 0,
			assessmentTotal: 0,
			searchOptions: {},
			selectedCompany: {},
			selectedIndex: null,
			selectedSkill: null,
			loadingMore: false,
			loadingData: true,
			isSkillExtracting: false,
			recommended: false,
			roadMap: null,
			roadMapLoader: false,
			formData: {
				companyName: "",
				companyRoleName: "",
				companyBio: "",
				jobDescription: "",
			},
			formErrors: {
				companyName: false,
				companyRoleName: false,
			},

			recentSearch: [],
			completedTestCount: 0,
			completedCourseCount: 0,
			config,
			recommendedJobRole: [],
			coursesList: [],

			coursePageEnd: 0,
			coursePageStart: 0,
			courseTotal: 0,
			coursePage: 0,
			loadmoreCourse: false,
			loadingCourse: false,
			loadingRecommendedrole: true,
			firstTime: true,
			mockInterviewTaken: 0,
			showPaymentComingSoonModal: false,
			querySkills: [],
			// pendingAction: null,
		};
	},
	components: {
		InputField,
		Textarea,
		AssessmentList,
		Loader,
		Spinner,
		PaymentComingSoonModal,
	},
	mixins: [commonFunction, toast],
	computed: {
		hasAccess() {
			return checkHasAccess();
		},
		headerText() {
			return this.byCompany ? "Prepare by Company/Role" : "Prepare by skill";
		},
		isFormValid() {
			return this.formData.companyName && this.formData.companyRoleName;
		},
		// Returns the display name for the currently selected company,
		// showing Board_Organization for gov/private jobs instead of companyName
		displayCompanyName() {
			let company = this.getDisplayName(this.selectedCompany);
			let role =
				this.selectedCompany &&
				(this.selectedCompany.companyRoleName ||
					this.selectedCompany.role ||
					this.selectedCompany.title);
			if (company && role) {
				return `${role} <span style="opacity: 0.5; font-weight: 300; margin: 0 4px;">|</span> ${company}`;
			} else if (company) {
				return company;
			} else if (role) {
				return role;
			}
			return "";
		},
		roadMapHtml() {
			if (!this.roadMap) return "";
			return this.roadMap
				.replace(/<table/gi, '<div class="roadmap-table-scroll"><table')
				.replace(/<\/table>/gi, "</table></div>");
		},
		...mapGetters({
			savedState: "candidateVUEX/getSavedInterviewSkillState",
		}),
	},
	mounted() {
		this.checkMobile();
		window.addEventListener("resize", this.checkMobile);
	},

	async created() {
		EventBus.$on("login-success", this.callCreatedActions);
		EventBus.$on("onboarding-fetch-post-login", this.callCreatedActions);
		EventBus.$on(
			"roadmap-onboarding-closed",
			this.fetchProfileAndCompanySkills
		);
		await this.createdActions();
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.checkMobile);
		EventBus.$off("login-success", this.callCreatedActions);
		EventBus.$off("onboarding-fetch-post-login", this.callCreatedActions);
		EventBus.$off(
			"roadmap-onboarding-closed",
			this.fetchProfileAndCompanySkills
		);
	},

	beforeRouteLeave(to, from, next) {
		const interviewFlow = [
			"InterviewSkills",
			"TakeAiInterview",
			"ReportAiInterview",
			"AiSkillInterview",
			"InterviewOngoing",
			"Report",
			"systemcheck",
		];
		if (
			to.name !== "InterviewSkills" &&
			this.savedState &&
			this.savedState.transientRoadmapSkills
		) {
			this.$store.commit("candidateVUEX/setSavedInterviewSkillState", null);
			this.clearRoadmapSkillsQuery();
		}
		if (!interviewFlow.includes(to.name)) {
			this.$store.commit("candidateVUEX/setSelectedCompany", {});
		}
		next();
	},

	methods: {
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		callCreatedActions() {
			if (this.isMobile) this.LoaderStatus = true;
			this.createdActions();
			// this.$nextTick(() => {
			// 	this.executePendingAction();
			// });
		},
		executePendingAction() {
			// Pending-action auto-trigger is disabled for now.
			// if (!this.pendingAction) return;
			// const action = this.pendingAction;
			// this.pendingAction = null;
			// if (action === "startInterview") {
			// 	this.startInterview();
			// } else if (action === "getSkillRoadmap") {
			// 	this.getSkillRoadmapSuggestions();
			// } else if (action === "goToReports") {
			// 	this.goToReports();
			// }
		},
		async createdActions() {
			this.byCompany = !!this.$route.query.bycompany;
			const roadmapSkills = this.getRoadmapSkillsFromQuery();
			if (roadmapSkills.length) {
				this.setRoadmapSkillsInSidebar(roadmapSkills);
				const sidebarBootstrap = this.hasAccess
					? Promise.allSettled([
							this.fetchProfileAndCompanySkills(),
							this.getCandidatePrimaryProfile(),
					  ])
					: Promise.resolve();

				await this.loadRoadmapSuggestionsFromQuery(roadmapSkills);
				await sidebarBootstrap;
				this.LoaderStatus = false;
				return;
			}

			if (
				this.savedState &&
				this.savedState.transientRoadmapSkills &&
				this.savedState.roadmapSkills
			) {
				this.setRoadmapSkillsInSidebar(this.savedState.roadmapSkills);
				const sidebarBootstrap = this.hasAccess
					? Promise.allSettled([
							this.fetchProfileAndCompanySkills(),
							this.getCandidatePrimaryProfile(),
					  ])
					: Promise.resolve();

				await this.loadRoadmapSuggestionsFromQuery(
					this.savedState.roadmapSkills
				);
				await sidebarBootstrap;
				this.LoaderStatus = false;
				return;
			}

			if (this.savedState && this.savedState.byCompany === this.byCompany) {
				this.profileSkills = this.normalizeSkillList(
					this.savedState.searchedSkills || []
				);
				this.recentSearch = this.savedState.recentSearch || [];
			}
			if (this.hasAccess) {
				await this.fetchProfileAndCompanySkills();
				await this.getCandidatePrimaryProfile();
			}

			if (this.byCompany) {
				this.formData.companyName = this.$route.query.company || "";
				this.formData.companyRoleName = this.$route.query.role || "";
				if (this.hasAccess) {
					await this.getRoadmapRecommendedJobs();
				}
			}

			if (this.$route.query.company && this.$route.query.role) {
				const qCompany = this.$route.query.company;
				const qRole = this.$route.query.role;

				// Bypass cache and force the API to run by clearing any existing duplicate
				this.recentSearch = this.recentSearch.filter(
					(item) =>
						!(item.companyName === qCompany && item.companyRoleName === qRole)
				);

				this.formData.companyName = qCompany;
				this.formData.companyRoleName = qRole;
				await this.prepareNow();
			} else if (this.$route.query.from === "jobsearch") {
				this.initializeFromJobSearch();
				return;
			} else {
				const hasIndexParam = this.$route.query.index !== undefined;

				if (hasIndexParam) {
					this.initializeWithIndexParam();
				} else if (!this.isMobile) {
					this.initializeDefaultSelection();
				}
			}

			if (!this.hasAccess) {
				this.showLeftSection = false;
			}

			this.LoaderStatus = false;
		},
		initializeFromJobSearch() {
			this.selectedProfileInd = 0;
			this.recommended = false;
			this.selectedCompany = this.recentSearch[0];

			if (this.selectedCompany) {
				const skillsToPass =
					this.selectedCompany.companySkills ||
					this.selectedCompany.skills ||
					[];
				this.handleSkillClick(
					skillsToPass,
					this.selectedProfileInd,
					this.recommended,
					this.byCompany
				);
			}
		},

		initializeWithIndexParam() {
			const index = parseInt(this.$route.query.index);
			const recommended = this.$route.query.rec === "1";

			if (this.byCompany) {
				this.initializeCompanyByIndex(index, recommended);
			} else {
				this.initializeSkillByIndex(index, recommended);
			}
		},

		initializeCompanyByIndex(index, recommended) {
			this.selectedCompany = recommended
				? this.recommendedJobRole[index]
				: this.recentSearch[index];

			if (!this.selectedCompany) {
				return;
			}

			const skills =
				this.selectedCompany.companySkills || this.selectedCompany.skills;
			this.handleSkillClick(skills, index, recommended, true);
		},

		initializeSkillByIndex(index, recommended) {
			const skill = recommended
				? this.recommendedSkills[index]
				: this.profileSkills[index];

			if (skill) {
				this.handleSkillClick(skill, index, recommended, false);
			}
		},

		initializeDefaultSelection() {
			if (this.byCompany) {
				this.handleSkillClick(this.recommendedJobRole[0].skills, 0, true, true);
			} else {
				this.handleSkillClick(this.profileSkills[0], 0, false, false);
			}
		},
		getRoadmapSkillsFromQuery() {
			const rawValue = this.$route.query.roadmapSkills;
			if (!rawValue || typeof rawValue !== "string") return [];

			try {
				let decoded = rawValue;
				for (let i = 0; i < 2; i++) {
					try {
						const nextDecoded = decodeURIComponent(decoded);
						if (nextDecoded === decoded) break;
						decoded = nextDecoded;
					} catch (error) {
						break;
					}
				}

				const parsedSkills = JSON.parse(decoded);
				if (!Array.isArray(parsedSkills)) return [];

				const skills = [];
				const seen = new Set();
				parsedSkills.forEach((skill) => {
					if (typeof skill !== "string") return;
					const normalized = skill.trim();
					const key = normalized.toLowerCase();
					if (normalized && !seen.has(key)) {
						seen.add(key);
						skills.push(normalized);
					}
				});

				return skills;
			} catch (error) {
				console.error("Invalid roadmapSkills query", error);
				return [];
			}
		},
		clearRoadmapSkillsQuery() {
			const updatedQuery = { ...this.$route.query };
			delete updatedQuery.roadmapSkills;
			this.$router.replace({
				path: this.$route.path,
				query: updatedQuery,
			});
		},
		setRoadmapSkillsInSidebar(skills) {
			const normalizedQuerySkills = [];
			const seen = new Set();
			skills.forEach((skill) => {
				const normalized = this.normalizeSkillName(skill || "");
				const key = normalized.toLowerCase();
				if (normalized && !seen.has(key)) {
					seen.add(key);
					normalizedQuerySkills.push(normalized);
				}
			});

			const existingSkills = this.profileSkills || [];
			const nonDuplicateExisting = existingSkills.filter((skillObj) => {
				const name = (skillObj?.name || "").trim().toLowerCase();
				return name && !seen.has(name);
			});

			const querySkillObjects = normalizedQuerySkills.map((skill) => ({
				name: skill,
				fromProfile: false,
				isRoadmapQuerySkill: true,
			}));

			this.profileSkills = [...querySkillObjects, ...nonDuplicateExisting];
			this.saveStateToVuex({
				transientRoadmapSkills: true,
				roadmapSkills: normalizedQuerySkills,
			});
		},
		async loadRoadmapSuggestionsFromQuery(skills) {
			this.byCompany = false;
			const firstSkill =
				Array.isArray(skills) && skills.length
					? this.normalizeSkillName(skills[0])
					: "";
			this.querySkills = firstSkill ? [firstSkill] : [];
			this.showTrans = false;
			this.assessmentPage = 0;
			this.coursePage = 0;
			this.assessmentSuggestions = [];
			this.coursesList = [];
			this.selectedProfileInd = firstSkill ? 0 : null;
			this.recommended = false;
			this.selectedSkill = {
				skill: {
					name: firstSkill,
					fromProfile: false,
				},
				index: 0,
				recommended: false,
				page: 0,
				byCompany: false,
			};

			this.loadingData = true;
			await this.fetchAssessmentSuggestions();
			await this.getCourseList();
			this.firstTime = false;
			if (this.isMobile) {
				this.showLeftSection = false;
			}
			this.loadingData = false;
		},
		// Single source of truth: returns Board_Organization for gov/private jobs,
		// otherwise falls back to companyName / company_name
		getDisplayName(company) {
			if (!company) return "";
			const type = (company.customFields?.Type_Govt_Private_ || "")
				.trim()
				.toLowerCase();
			if (
				["gov", "private"].includes(type) &&
				company.customFields?.Board_Organization
			) {
				return company.customFields.Board_Organization;
			}
			return company.companyName || "";
		},
		normalizeSkillName(name) {
			if (typeof name !== "string") return "";
			// Ignore expertise suffix for Interview Skills page display and payloads.
			return name.replace(/\s*:[1-4]\s*$/, "").trim();
		},
		normalizeSkillObject(skillObj) {
			if (!skillObj || typeof skillObj !== "object") return skillObj;
			return {
				...skillObj,
				name: this.normalizeSkillName(skillObj.name),
			};
		},
		normalizeSkillList(skills) {
			if (!Array.isArray(skills)) return [];
			return skills.map((skill) =>
				typeof skill === "string"
					? this.normalizeSkillName(skill)
					: this.normalizeSkillObject(skill)
			);
		},

		updateFormData(field, value) {
			this.formData[field] = value;
			if (this.formErrors[field] !== undefined) {
				this.formErrors[field] = false;
			}
		},

		resetForm() {
			this.formData = {
				companyName: "",
				companyRoleName: "",
				companyBio: "",
				jobDescription: "",
			};
			this.formErrors = {
				companyName: false,
				companyRoleName: false,
			};
		},
		goToReports() {
			if (!this.hasAccess) {
				// this.pendingAction = "goToReports";
				this.openLoginModal();
				return;
			}
			if (this.mockInterviewTaken == 0) return;
			this.$router.push({
				name: "ReportAiInterview",
				query: this.$route.query,
			});
		},

		startInterview() {
			if (!this.hasAccess) {
				// this.pendingAction = "startInterview";
				this.openLoginModal();
				return;
			}
			console.log(this.mockInterviewTaken, "mockInterviewTaken");
			if (this.mockInterviewTaken >= 2) {
				this.showPaymentComingSoonModal = true;
				return;
			}
			if (this.byCompany) {
				this.$store.commit(
					"candidateVUEX/setSelectedSkillsForInterview",
					this.selectedCompany.companySkills || this.selectedCompany.skills
				);
				this.$store.commit(
					"candidateVUEX/setSelectedCompany",
					this.selectedCompany
				);
			} else {
				this.$store.commit(
					"candidateVUEX/setSelectedSkillsForInterview",
					this.selectedSkill.skill
				);
				this.$store.commit("candidateVUEX/setSelectedCompany", {});
			}
			this.saveStateToVuex();
			this.$router.push({ name: "TakeAiInterview", query: this.$route.query });
		},

		handleMockInterviewClick() {
			if (this.mockInterviewTaken > 0) {
				this.showMobileOptions = true;
			} else {
				this.startInterview();
			}
		},
		onCourseScroll(e) {
			// Check if mobile view (adjust breakpoint as needed, e.g., 1028px matches your CSS)
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
					target.scrollHeight - target.offsetHeight - 10 && // Added buffer
				!this.loadmoreCourse
			) {
				if (this.checkbetween(this.coursePageEnd, 0, this.courseTotal)) {
					this.loadmoreCourse = true;
					this.coursePage++;
					this.getCourseList();
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},

		async addToWishlist(course) {
			const isAdding = !course.wishlistInfo;
			const payload = { itemID: course.courseID };

			const res = await toggleWishlist(payload, isAdding);

			if (res.status == 200) {
				let message = isAdding
					? res.data.data.Detail
					: "Course removed from wishlist";
				this.successModal("Success", message);
				course.wishlistInfo = isAdding;
			}
		},

		getButtonText(course) {
			if (!course.isEnrolled) {
				return course.pricing.finalPrice > 1 ? "Purchase Now" : "Enroll Now";
			} else if (course.progress != 0) {
				return "Resume";
			} else {
				return "Get Started";
			}
		},

		goToCourse(cData) {
			this.saveStateToVuex();
			let link = `${this.config.trainingBase}/coursedetail/${
				cData.courseID || cData.referenceID
			}?courseName=${cData.title || cData.courseName}`;
			window.open(link, "_self");
		},

		async handleJobRoleClick(role, index, recommended = false) {
			this.firstTime = true;
			this.selectedCompany = role;
			await this.prepareNow(index, true, role, recommended);
		},

		async prepareNow(
			index = 0,
			fromClick = false,
			role = null,
			recommended = false
		) {
			this.loadPrepare = true;
			if (this.isSkillExtracting) return;
			this.isSkillExtracting = true;
			if (!fromClick && !role) {
				const { companyName, companyRoleName } = this.formData;

				if (!companyName || !companyRoleName) {
					this.formErrors.companyName = !companyName;
					this.formErrors.companyRoleName = !companyRoleName;

					this.formErrors.companyName = !companyName;
					this.formErrors.companyRoleName = !companyRoleName;

					return;
				}

				const duplicate = this.recentSearch.some(
					(item) =>
						item.companyName === companyName &&
						item.companyRoleName === companyRoleName
				);

				if (duplicate) {
					this.errorModal("Error", "Duplicate entry found");
					return;
				}
			}

			const payload = {
				companyName: this.formData.companyName || role.companyName,
				role: this.formData.companyRoleName || role.companyRoleName,
				companybio: this.formData.companyBio || role?.companyBio || "",
				jd: this.formData.jobDescription || role?.jobDescription || "",
			};
			if (role != null && (role?.companySkills || role?.skills)) {
				const skillRequired = role.companySkills || role.skills;
				this.selectedCompany = role;
				this.handleSkillClick(skillRequired, index, recommended, true);
			} else {
				this.selectedProfileInd = index;
				this.recommended = recommended;
				try {
					const res = await extractSkills(payload);
					if (res.status == 200) {
						this.recentSearch.unshift({
							companyName: this.formData.companyName,
							companyRoleName: this.formData.companyRoleName,
							companyBio: this.formData.companyBio,
							jobDescription: this.formData.jobDescription,
							companySkills: res.data.skills,
						});
						this.selectedCompany = this.recentSearch[0];
						this.handleSkillClick(res.data.skills, index, recommended, true);
					}
				} catch (error) {
					console.log(error);
					// throw new error;
				}
			}
			this.isSkillExtracting = false;
			this.loadPrepare = false;
			if (!fromClick) {
				this.resetForm();
			}
		},

		async getRoadmapRecommendedJobs() {
			this.loadingRecommendedrole = true;
			if (!this.hasAccess || !this.candidateData || !this.candidateData._id) {
				this.loadingRecommendedrole = false;
				return;
			}
			const payload = {
				profileID: this.candidateData._id,
				experienceLevel: this.candidateData.experienceLevel,
				skills: this.profileSkills.map((skill) =>
					this.normalizeSkillName(skill.name)
				),
				yearOfExperience: 2,
				preferredLocations: this.candidateData.preferredLocations,
				workType: this.candidateData.workType,
			};

			const res = await getRoadmapRecommendedJobs(payload);
			if (res.status == 200) {
				this.recommendedJobRole = res.data.companyDetails;
				if (this.recentSearch.length == 0) {
					this.selectedCompany = this.recommendedJobRole[0];
				}
			}
			this.loadingRecommendedrole = false;
		},

		async getSkillRoadmapSuggestions() {
			if (!this.hasAccess) {
				// this.pendingAction = "getSkillRoadmap";
				this.openLoginModal();
				return;
			}
			this.roadMapLoader = true;
			let payload;

			if (this.byCompany) {
				const { companyName, companyRoleName, companyBio, jobDescription } =
					this.formData;

				payload = {
					type: 2,
					companyName:
						companyName ||
						this.selectedCompany.companyName ||
						this.selectedCompany.company_name,
					companySkills:
						this.selectedSkill.skill ||
						this.selectedCompany.companySkills ||
						this.selectedCompany.skills,
					role:
						companyRoleName ||
						this.selectedCompany.companyRoleName ||
						this.selectedCompany.role ||
						"others", // Default to 'others' if role is not available
					jd:
						jobDescription ||
						this.selectedCompany.jobDescription ||
						this.selectedCompany.job_description,
					companybio:
						companyBio ||
						this.selectedCompany.companyBio ||
						this.selectedCompany.company_bio,
					source: "search",
				};
			} else {
				payload = {
					overallSkills: this.profileSkills.map((skill) =>
						this.normalizeSkillName(skill.name)
					),
					roadMapSkill: this.normalizeSkillObject(this.selectedSkill.skill),
					source: this.selectedSkill.skill.fromProfile ? "profile" : "search",
					type: 1,
				};
			}

			const resp = await getSkillRoadmapSuggestions(payload);
			try {
				if (resp.status === 200 || resp.status === 201) {
					this.roadMap = resp.data.data.roadMap.roadmap;
					this.selectedSkill.skill.roadMapCreated = true;
					this.showTrans = true;
				}
			} catch (error) {
				console.log(error);
				this.errorModal("Error", "Something went wrong");
			} finally {
				this.roadMapLoader = false;
				this.saveStateToVuex();
			}
		},
		handleBackLaptop() {
			if (this.$route.query.from === "kickstart") {
				this.$router.go(-1);
			} else if (this.$route.query.from === "jobsearch") {
				this.$router.push({ name: "JobSearch" });
			} else if (
				this.$route.query.from === "dashboard" ||
				this.$route.query.from === "home"
			) {
				this.$router.push({ name: "Homepage" });
			} else {
				this.$router.push({ name: "CandidateDashboard" });
			}
		},
		handleBack() {
			// 1. Close roadmap overlay
			if (this.showTrans) {
				this.showTrans = false;
				return;
			}

			// 2. Mobile: right panel → left list
			if (this.isMobile && !this.showLeftSection) {
				// Preserve important query params when going from right to left panel
				const preservedQuery = {};
				if (this.$route.query.from) {
					preservedQuery.from = this.$route.query.from;
				}
				if (this.$route.query.bycompany) {
					preservedQuery.bycompany = this.$route.query.bycompany;
				}

				this.$router.replace({ query: preservedQuery });
				this.showLeftSection = true;
				return;
			}

			// 3. If query exists → clear it (first back)
			if (this.$route.query.skill) {
				// Preserve important query params when clearing skill-specific params
				const preservedQuery = {};
				if (this.$route.query.from) {
					preservedQuery.from = this.$route.query.from;
				}
				if (this.$route.query.bycompany) {
					preservedQuery.bycompany = this.$route.query.bycompany;
				}

				this.$router.replace({ query: preservedQuery });

				// reset UI
				this.selectedSkill = null;
				this.selectedProfileInd = null;
				this.recommended = false;
				this.showLeftSection = true;
				return;
			}

			// 4. Check if coming from Interview Kickstart ("Prepare Now")
			if (this.$route.query.from === "kickstart") {
				this.$router.go(-1);
				return;
			}

			// 4a. Check if coming from job search
			if (this.$route.query.from === "jobsearch") {
				this.$router.push({ name: "JobSearch" });
				return;
			}

			// 4b. Coming from the New Dashboard (AI Interview "Explore More")
			if (
				this.$route.query.from === "dashboard" ||
				this.$route.query.from === "home"
			) {
				this.$router.push({ name: "Homepage" });
				return;
			} else {
				this.$router.push({
					name: "CandidateDashboard",
				});
			}
		},
		closeSuggestions() {
			this.tempSearchQuery = "";
			this.searchOptions = {};
		},

		selectOption(option, index) {
			const normalizedOption = this.normalizeSkillName(option.text);
			if (
				this.profileSkills.find(
					(skill) => this.normalizeSkillName(skill.name) === normalizedOption
				)
			)
				return;
			const newSkill = {
				name: normalizedOption,
				fromProfile: false,
			};
			this.profileSkills = [newSkill, ...this.profileSkills];
			this.firstTime = true;
			this.handleSkillClick(newSkill, 0);
			this.tempSearchQuery = "";
			this.searchOptions = {};
		},

		async searchSkills() {
			try {
				const payload = {
					search: this.tempSearchQuery,
					page: 0,
				};
				const resp = await getSkillSuggestions(payload);
				if (resp.status === 200) {
					this.searchOptions = resp.data.data.response;
				}
			} catch (error) {
				console.error(error);
			}
		},

		async fetchProfileAndCompanySkills() {
			if (!this.hasAccess) {
				this.loadingSkills = false;
				return;
			}
			try {
				this.loadingSkills = true;
				const resp = await getProfileSkills();
				if (resp.status === 200) {
					const allResp = resp.data.data.data;
					this.mockInterviewTaken = allResp.mock_interview_taken;

					const apiSkills = this.normalizeSkillList(allResp.profile_skills);
					const searchedSkills = this.profileSkills.filter(
						(s) => !s.fromProfile
					);
					const filteredApiSkills = apiSkills.filter(
						(as) =>
							!searchedSkills.some(
								(ss) =>
									this.normalizeSkillName(ss.name) ===
									this.normalizeSkillName(as.name)
							)
					);
					this.profileSkills = [...searchedSkills, ...filteredApiSkills];

					const skillRoadmaps = (allResp.roadmaps || []).filter(
						(item) => item.type == 1
					);

					this.profileSkills.forEach((skill) => {
						const hasRoadmap = skillRoadmaps.some((rm) => {
							const rmName =
								rm.title ||
								rm.skillName ||
								rm.skill ||
								rm.name ||
								rm.companyName;
							return (
								rmName &&
								this.normalizeSkillName(rmName) ===
									this.normalizeSkillName(skill.name)
							);
						});
						if (hasRoadmap) {
							this.$set(skill, "roadMapCreated", true);

							if (
								this.selectedSkill &&
								this.selectedSkill.skill &&
								this.normalizeSkillName(this.selectedSkill.skill.name) ===
									this.normalizeSkillName(skill.name)
							) {
								this.$set(this.selectedSkill.skill, "roadMapCreated", true);
							}
						}
					});

					const apiRecentSearch = allResp.roadmaps.filter(
						(item) => item.type == 2
					);

					const localRecentSearch = this.recentSearch || [];
					const mergedRecentSearch = [...localRecentSearch];
					apiRecentSearch.forEach((as) => {
						if (
							!mergedRecentSearch.some(
								(ls) =>
									ls.companyRoleName === as.companyRoleName &&
									ls.companyName === as.companyName
							)
						) {
							mergedRecentSearch.push(as);
						}
					});

					this.recentSearch = mergedRecentSearch;

					// Check if there is a selected company from the Job Search page
					const selectedCompanyFromStore =
						this.$store.state.candidateVUEX.selectedCompany;
					// only if we are in "byCompany" mode
					if (this.byCompany && selectedCompanyFromStore) {
						// Some normalization because LaptopJobSearch object != recentSearch object
						const companyName =
							selectedCompanyFromStore.customerName ||
							selectedCompanyFromStore.companyName;

						if (companyName) {
							// Add to the top of recentSearch (avoid duplicates if possible)
							this.recentSearch = this.recentSearch.filter(
								(item) =>
									item.companyName !== companyName ||
									item.companyRoleName !== selectedCompanyFromStore.role
							);

							// The store usually has the full job object. Mapping it to recentSearch structure:
							const newRecentItem = {
								companyName: companyName,
								companyRoleName: selectedCompanyFromStore.role,
								companyBio: selectedCompanyFromStore.companyBio || "",
								jobDescription: selectedCompanyFromStore.description || "",
								companySkills: selectedCompanyFromStore.skills || [],
								// Keep original object properties just in case
								...selectedCompanyFromStore,
							};

							this.recentSearch.unshift(newRecentItem);
							this.selectedCompany = this.recentSearch[0];
						}
					}

					this.mockInterviewTaken = allResp.mock_interview_taken;
					if (this.byCompany && this.recentSearch.length === 0) {
						return;
					}

					const profileSkills = this.byCompany
						? this.recentSearch[0]?.companySkills
						: this.profileSkills[0];

					this.recommendedSkills = this.normalizeSkillList(
						allResp.suggested_skills
					);
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.loadingSkills = false;
			}
		},

		checkMobile() {
			this.isMobile = window.innerWidth <= 1028;
		},

		async handleSkillClick(
			skill,
			index,
			recommended = false,
			byCompany = false
		) {
			if (this.loadingMore) return;
			if (skill) {
				this.querySkills = [];
			}

			let page = 0;
			this.showTrans = false;

			if (!skill && this.selectedSkill) {
				skill = this.selectedSkill.skill;
				index = this.selectedSkill.index;
				recommended = this.selectedSkill.recommended;
				byCompany = this.selectedSkill.byCompany;
				page = this.selectedSkill.page + 1;

				const lastPage = this.total / 10;
				if (page >= lastPage) return;

				this.loadingMore = true;
			} else {
				this.loadingData = true;
				this.assessmentPage = 0;
				this.coursePage = 0;
				this.selectedSkill = { skill, index, recommended, page, byCompany };
			}

			this.selectedProfileInd = index;
			this.recommended = recommended;

			await this.fetchAssessmentSuggestions();

			this.getCourseList();
			this.firstTime = false;

			if (this.isMobile) {
				this.showLeftSection = false;
			}

			this.loadingMore = false;
			this.loadingData = false;
			this.saveStateToVuex();

			// Preserve the 'from' parameter when updating query
			const newQuery = {
				...this.$route.query,
				skill: this.byCompany
					? ""
					: this.normalizeSkillName(this.selectedSkill.skill.name),
				index: index,
				rec: recommended ? 1 : 0,
				byCompany: byCompany ? 1 : 0,
			};

			// Ensure 'from' parameter is preserved if it exists
			if (this.$route.query.from) {
				newQuery.from = this.$route.query.from;
			}
			this.$router.replace({
				query: newQuery,
			});
		},

		saveStateToVuex(extraState = {}) {
			this.$store.commit("candidateVUEX/setSavedInterviewSkillState", {
				searchedSkills: this.profileSkills.filter((s) => !s.fromProfile),
				recentSearch: this.recentSearch,
				byCompany: this.byCompany,
				...extraState,
			});
		},

		handleAssessmentScroll() {
			this.loadingMore = true;
			this.assessmentPage++;
			this.fetchAssessmentSuggestions();
		},

		async fetchAssessmentSuggestions() {
			const payload = {
				skill: this.byCompany
					? this.selectedCompany.companySkills || this.selectedCompany.skills
					: this.querySkills.length
					? this.normalizeSkillList(this.querySkills)
					: this.normalizeSkillName(this.selectedSkill.skill.name),
				email: this.candidateData ? this.candidateData.email : "",
				count: 10,
				page: this.assessmentPage,
			};

			const resp = await getAssessmentSuggestions(payload);

			if (resp.status === 200) {
				if (this.assessmentPage == 0) {
					this.assessmentSuggestions = resp.data.data.data;
				} else {
					this.assessmentSuggestions = [
						...this.assessmentSuggestions,
						...resp.data.data.data,
					];
				}
				this.assessmentPageEnd = resp.data.data.pageEnd;
				this.assessmentPageStart = resp.data.data.pageStart;
				this.assessmentTotal = resp.data.data.total;
				this.completedTestCount = resp.data.data.completedTestCount;
			}
			this.loadingMore = false;
			this.loadingData = false;
		},

		async getCourseList() {
			const payload2 = {
				count: 5,
				page: this.coursePage,
				matchedSkills: true,
				skills: this.selectedSkill.byCompany
					? this.selectedSkill.skill
					: this.querySkills.length
					? this.querySkills
					: [this.selectedSkill.skill.name],
				ratingSummaryInfo: true,
				wishlistInfo: true,
				instructorInfo: true,
			};

			const resp = await getcoursesList(payload2);
			if (resp.status === 200) {
				if (this.coursePage == 0) {
					this.coursesList = resp.data.data.data;
				} else {
					this.coursesList = [...this.coursesList, ...resp.data.data.data];
				}
				this.coursePageEnd = resp.data.data.pageEnd;
				this.coursePageStart = resp.data.data.pageStart;
				this.courseTotal = resp.data.data.total;
				this.completedCourseCount = resp.data.data.completedCount || 0;
				this.loadmoreCourse = false;
				if (this.isMobile && this.coursePage === 0) {
					if (this.assessmentTotal === 0 && this.coursesList.length > 0) {
						this.activeTab = 1;
						this.showAssessments = false;
						this.showCourses = true;
					} else {
						this.activeTab = 0;
						this.showAssessments = true;
						this.showCourses = false;
					}
				}
			}
		},

		checkActiveTab(tabIndex) {
			if (tabIndex === 0) {
				this.showAssessments = true;
				this.showCourses = false;
			} else if (tabIndex === 1) {
				this.showAssessments = false;
				this.showCourses = true;
			}
		},
	},
};
</script>
<style lang="scss">
.interview-skill-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow-x: hidden;
	align-items: center;
}
.interview-skill-container.guest-padding {
	padding-left: 15px !important;
}
.interview-skill-container .cand-header {
	background-color: #20639b14;
}
.inski-container {
	display: flex;
	gap: 22px;
	margin-top: 10px;
	height: calc(100vh - 158px);
	width: 100%;
}
.inki-left {
	width: 27%;
	border-radius: 6px;
	background-color: #fdfdfd;
	padding-block: 15px;
	overflow: auto;
}
.inki-right {
	width: 73%;
}
.inki-left .resumes-search-input {
	height: 32px;
}
.inki-left .resumes-search-image-position {
	left: 27px;
	top: 8px;
}
.inki-left hr {
	background-color: #d6d6d6;
	opacity: 1;
}
.mt-12 {
	margin-top: 12px;
}
.inki-left-overflow {
	max-height: calc(100vh - 466px);
	overflow: auto;
	padding-left: 15px;
}
.inki-left-overflow .skill {
	border: 1px solid #20639b1f;
	background-color: #fff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px 10px 14px;
	margin-bottom: 10px;
	width: calc(100% - 15px);
}
.inki-left-overflow .skill:hover {
	background-color: #eff4f8;
}
.inki-left-overflow .skill article {
	font-size: 13px;
	font-weight: 700;
	font-style: italic;
	font-family: "lato", sans-serif;

	border-radius: 12px;
}
.inki-left-overflow .skill.selected {
	border: 1px solid #20639b;
	border-left: 5px solid #20639b;
	background-color: #eff4f8;
	padding: 10px 12px 10px 10px;
}
.inki-left-overflow .skill .tag {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-style: Italic;
	font-size: 13px;
	color: #405c77;
}

.recomended div {
	border: 1px solid #20639b1f;

	border-radius: 5px;
	padding: 4px 4px 4px 12px;
	width: calc((100% - 16px) / 2);
}
.recomended .recom-sel {
	background: #20639b1a !important;
	padding: 4px 4px 4px 9px !important;
	border-radius: 5px;
	border: 1px solid #20639b;
	border-left: 5px solid #20639b;
}
.no-assessment {
	min-height: calc(100vh - 485px);
}
.inki-right .dflex-1 {
	display: flex;
	gap: 20px;
}
.inki-right .roadmap {
	background-color: #f3f6ff;
	border: 1px solid #8c8c8c4d;
	border-radius: 8px;
	padding: 10px;
	display: flex;
	flex: 1;
}
.inki-right .mockInter {
	background-color: #f3f6ff;
	border: 1px solid #8c8c8c4d;
	border-radius: 8px;
	padding: 10px;
	display: flex;
	flex: 1;
}
.inki-right .btn {
	padding: 6px 20px !important;
}
.inki-skill-heading {
	background-color: #20639b;
	border-radius: 4px 4px 0px 0px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 400;
	color: #e0e0e0;
	padding: 8px 15px;
}
.inki-skill-heading .vert-line {
	width: 1px;
	height: 20px;
	background-color: #e0e0e0;
	opacity: 0.25;
}
.iski-topDiv .d-flex {
	flex-direction: column;
	align-items: flex-start !important;
	gap: 5px;
}
.iski-topDiv .w-40,
.iski-topDiv .w-16 {
	width: 100%;
}
.inki-left .blue-recom {
	background: #ffffff;
	padding: 16px;
	border-radius: 8px;
}
.inki-left .blue-recom-role {
	background: #20639b1a;
	padding: 16px;
	border-radius: 8px;
}
.inki-left .white-recom {
	background: #20639b1a !important;
	padding: 16px;
	border-radius: 8px;
	border: 1px solid #20639b;
	border-left: 5px solid #20639b;
}
.jobsearch-highlight {
	background: #20639b1a !important;
	border: 1px solid #20639b !important;
	border-left: 5px solid #20639b !important;
}
.inki-collapse .header {
	background-color: #f7f9fb;
	padding: 12px 16px;
	border-bottom: 1px solid #dddddd;
	cursor: pointer;
}
/* when collapse is open */
.inki-collapse:has(.collapse.show) .header {
	background-color: #fff; /* white */
	border-bottom: 1px dashed #fff;
}

.inki-collapse .completed-tag {
	background: #20639b14;
	border-radius: 6px;
	padding: 4px 10px;
}
.inki-collapse .body {
	padding: 0 30px 15px 30px;
	background-color: #fff;
}
.inki-collapse .dashed-div {
	height: 15px;
	border-top: 2px dashed #dddddd;
}
.inki-collapse .asmnt-card {
	border: 1px solid #e2e8f0;
	justify-content: space-between;
	border-radius: 8px;
	padding: 12px;
}

.inki-collapse .asp-top-card {
	border-bottom: none;
	width: 50%;
	padding-bottom: 0;
}
.asp-completed-tag {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: var(--cv-green);
	background-color: #f6f9fb;
	border-radius: 8px;
	padding: 1px 19px;
}
.inki-collapse .course-card {
	border: 1px solid #20639b1a;
	box-shadow: 0px 4px 12px 0px #c4c4c480;
	border-radius: 10px;
	padding: 10px 20px 10px 10px;
	background-color: #fff;
	display: flex;
	width: 100%;
}
.main-dp {
	height: 150px;
	width: 150px;
	border-radius: 6px;
	/* background-color: #405c77; */
}
.course-rating {
	width: 100px;
}

.course-rating .form-control {
	background-color: transparent;
	border: none;
	padding: 0;
}

.course-rating .form-control:focus {
	box-shadow: none;
}

.course-rating svg {
	width: 15px;
	height: 15px;
}

.course-rating .b-rating .b-rating-star,
.b-rating .b-rating-value {
	padding: 0;
}
.inki-right-overflow {
	height: calc(100vh - 328px);
	overflow: auto;
}

.inki-right-overflow-loggedout {
	height: calc(100vh - 280px) !important;
}
.sws-select-options {
	position: absolute;
	overflow: auto;
	border: 1px solid #2988e638;
	background-color: #f9f9f9;
	z-index: 3;
	border-radius: 4px;
	width: 94%;
	box-shadow: 0px 8px 15px 0px #00000066;
	list-style-type: none;
	padding-left: 0px;
	max-height: 124px;
}
.search-select-option {
	cursor: pointer;
	color: #333 !important;
	font-size: 13px !important;
	font-weight: 500 !important;
}

.search-select-options .search-select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}

.search-select-option:hover {
	background-color: #e8eff4;
}

.search-select-option.selected {
	background-color: #c8d9e5;
}
.sticky-header {
	top: 0;
	z-index: 10;
}
.courses-wrapper .scrollable-list {
	max-height: calc(100vh - 480px);
	overflow-y: auto;
}
.assessment-list-wrapper .scrollable-list {
	max-height: calc(100vh - 480px);
	overflow-y: auto;
}
.roadmap-overparent {
	font-family: "lato", sans-serif;
	h1 {
		font-family: "Montserrat", sans-serif;
		font-weight: 600;
		font-size: 20px;
		margin-top: 20px;
	}
	/* h1::before {
		top: 12px;
		content: "";
		position: absolute;
		left: 0;
		transform: translateY(-50%);

		width: 16px;
		height: 16px;

		background-color: #20639b;
		-webkit-mask: url("../../assets/3dotsanddash.svg") no-repeat center;
		mask: url("../../assets/3dotsanddash.svg") no-repeat center;
		-webkit-mask-size: contain;
		mask-size: contain;
	} */
	h2 {
		font-family: "Montserrat", sans-serif;
		font-weight: 600;
		font-size: 18px;
	}
	h3 {
		font-family: "Lato", sans-serif;
		font-weight: 700;
		font-size: 18px;
		color: #0d0d0d;
	}
	li {
		font-family: "Lato", sans-serif;
		font-weight: 400;
		font-size: 16px;
		color: #333;
		margin-bottom: 7px;
	}
	p {
		margin-bottom: 10px;
	}
	p strong,
	p b {
		font-weight: 500;
	}
	h3 {
		padding-top: 20px;
		margin-top: 20px;
		border-top: 1px solid #e2e2e2;
		font-family: "montserrat", sans-serif;
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 15px;
	}
	/* h3::before {
		top: 30px;
		content: "";
		position: absolute;
		left: 0;
		transform: translateY(-50%);

		width: 16px;
		height: 16px;

		background-color: #20639b;
		-webkit-mask: url("../../assets/3dotsanddash.svg") no-repeat center;
		mask: url("../../assets/3dotsanddash.svg") no-repeat center;
		-webkit-mask-size: contain;
		mask-size: contain;
	} */
	li a {
		background: #20639b1a;
		border-radius: 15px;
		padding: 4px 10px;
		color: #20639b;
		font-family: "Montserrat", sans-serif;
		font-weight: 500;
		font-size: 12px;
	}
	ul {
		padding-left: 38px;
	}
	ul:has(li > a) {
		padding-left: 20px;
		list-style: none;
	}
	ul:has(> li > a):not(:has(ul)) {
		padding-left: 20px;
		list-style: none;
		display: flex;
		gap: 0 13px;
		flex-wrap: wrap;
	}
	.stage {
		margin-top: 20px;
	}
	.stage p {
		padding-left: 20px;
	}
	li::marker {
		color: #0d0d0d;
	}

	.roadmap-table-scroll {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		max-width: 100%;
	}
	table {
		min-width: 700px;
		border-width: 0px;
	}
	tbody tr:first-child {
		font-weight: 700;
	}
	tr {
		font-family: "lato", sans-serif;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		border-bottom: 1px solid #e2e2e2;
	}
}

@media (max-width: 1028px) {
	.mob-mt-4 {
		margin-top: 1rem;
	}
	.courses-wrapper .scrollable-list {
		max-height: calc(100vh - 350px);
		overflow-y: auto;
	}
	.assessment-list-wrapper .scrollable-list {
		max-height: calc(100vh - 350px);
		overflow-y: auto;
	}
	.interview-skill-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		padding: 0px !important;
		overflow-y: auto !important;
		overflow-x: hidden !important;
		position: fixed !important;
		top: unset !important;
		display: unset !important;
	}
	.inski-container {
		flex-direction: column;
		margin-top: unset;
		height: 100%;
		overflow: auto;
	}
	.inki-left {
		width: 100%;
		border-radius: 6px;
		background-color: transparent;
		padding-block: 15px;
		padding-inline: 15px;
		/* overflow: unset; */
		height: 100%;
	}
	.iski-topDiv #hideinlaptop {
		display: none;
	}
	.iski-topDiv #hideinmobile {
		display: block !important;
	}
	.iski-topDiv .d-flex {
		gap: 0px;
	}
	/* .inki-left .px-3{
	padding-left: 0px !important;
	padding-right: 0px !important;
}
.inki-left .blue-recom.mx-3,.inki-left hr.mx-3,.iski-mob-ml.ml-3{
	margin-left: 0px !important;
	margin-right: 0px !important;
} */
	.inki-left-overflow {
		max-height: calc(100% - 290px);
		/* padding-left: 0px; */
	}
	.inki-left-overflow .skill {
		width: calc(100% - 15px);
	}
	.recomended div {
		border: 1px solid #fff;
		background: #ffffff !important;
		padding: 7px 12px !important;
	}
	.inki-right {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding-inline: 15px;
	}
	.iski-mob-collapse {
		background: linear-gradient(179.67deg, #20639b 0.28%, #000a26 142.24%);
		border: 1px solid #8c8c8c4d;
		padding: 16px;
		border-radius: 0px 0px 8px 8px;
		width: 100%;
		border-top: none;
	}
	.interview-skill-container.guest-padding {
		padding: 0px !important;
		top: calc(74px + env(safe-area-inset-top)) !important;
		margin-top: 0px !important;
	}
	.iski-mob-collapse .dashed-div {
		border-top: 2px dashed #7b95ae;
	}
	.iski-mob-collapse .card {
		background: #f3f6ff;
		border: 1px solid #8c8c8c4d;
		border-radius: 8px;
		position: relative;
		padding: 15px;
		overflow: hidden;
		flex: 1;
	}
	.iski-mob-collapse .card img {
		position: absolute;
		right: 0;
		bottom: 0;
	}
	.iski-mob-collapse .card span {
		width: 60%;
	}
	.inki-collapse .body {
		padding: 15px;
		background-color: transparent;
	}
	.inki-right .nav-tabs .nav-link.active,
	.inki-right .nav-tabs .nav-item.show .nav-link {
		color: var(--bg-white);
		background-color: var(--bg-proTheme);
		border-radius: 6px;
		display: flex;
		align-items: center;
		border: none;
	}
	.inki-right .nav-tabs .nav-link {
		font-size: var(--size-12);
		flex: 1;

		margin-bottom: 0;
		background-color: #d7e0ef;
		border: none;
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: "Montserrat", sans-serif;
		font-weight: var(--weight-M);
		color: #40404c;
	}
	.inki-right .tabs.w-100 {
		width: calc(100% - 30px) !important;
	}
	.inki-right .tabs {
		margin: 15px;
		padding: 2px;
		background-color: #d7e0ef;
		border-radius: 4px;
	}
	.inki-right .nav-tabs {
		width: 100%;
		background-color: #d7e0ef;
		border-radius: 6px;
		border-bottom: none;
	}

	.inki-right ul li {
		width: calc(100% / 2);
	}
	.inki-right .nav-link {
		padding-inline: unset;
		text-align: center;
	}
	.inki-right .nav-tabs span {
		background-color: #e9f0f5;
		border-radius: 50%;
		height: 18px;
		width: 18px;
	}

	.collapsing {
		transition: height 0.5s ease;
	}
	.inki-collapse .body {
		padding: 0px 15px 15px 15px;
	}
	.inki-right-overflow {
		height: calc(100% - 295px);
	}
	.main-dp {
		height: 110px;
		width: 105px;
	}
	.mob-gap-3 {
		gap: 10px !important;
	}
	.inki-collapse .course-card {
		padding: 10px;
	}
	.course-rating .form-control {
		height: 29px;
	}
	.inki-dflex {
		display: flex;
		flex-direction: row !important;
		align-items: center !important;
		justify-content: space-between !important;
	}
	.text-name {
		color: #20639b;
	}
	.inki-collapse .course-card hr {
		margin-top: 4px;
		margin-bottom: 4px;
	}
	.inki-collapse .asmnt-card {
		flex-direction: column;
		background-color: #fff;
	}
	.inki-collapse .asmnt-card .mob-flex-column {
		align-items: flex-start !important;
	}
	.inki-collapse .asp-top-card {
		border-bottom: 1px solid #ddd;
		width: 100%;
		padding-bottom: 10px;
	}
	.asp-completed-tag {
		font-size: 10px;
		padding: 1px 3px;
	}
	.mob-ml-2.ml-2 {
		margin-left: 0 !important;
	}
	.mob-inki-height {
		height: unset !important;
	}
	.interview-skill-container .jdprog-trans-main-cont {
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		top: calc(0px + env(safe-area-inset-top));
		width: 100%;
		border-radius: 0;
		background-color: #e9ecef;
		overflow-x: hidden;
	}
	.interview-skill-container .jdp-trans-overflow-2 {
		height: 100%;
	}
}
</style>

<style scoped>
.mobile-options-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 10001;
	display: flex;
	align-items: flex-end;
}

.mobile-options-sheet {
	width: 100%;
	background: white;
	border-radius: 20px 20px 0 0;
	padding-bottom: calc(20px + env(safe-area-inset-bottom));
	animation: slideUp 0.3s ease-out;
}

.sheet-handle {
	width: 40px;
	height: 4px;
	background: #e0e0e0;
	border-radius: 2px;
}

.option-card {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background: #fff;
	transition: all 0.2s;
}

.option-card:active {
	background: #f8f9fa;
}

.icon-box {
	min-width: 50px;
	height: 50px;
	/* background: #F2F6FE; */
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}

@keyframes slideUp {
	from {
		transform: translateY(100%);
	}
	to {
		transform: translateY(0);
	}
}
</style>
